import React, { useState, useEffect } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles({ title: { textAlign: 'center' } })

export default function TermsOfServiceDialog(props) {
  const { app, api, open, close } = props

  const classes = useStyles()
  const [termsOfService, setTermsOfService] = useState('')

  useEffect(() => {
    async function setTos(app, api){
      let tos = ''

      if(app.userGeneratedContentTermsOfService){
        tos = app.userGeneratedContentTermsOfService
      }else{
        tos = await api.tos().get()
      }
      setTermsOfService(tos)
    }

    setTos(app, api)
  }, [app, api])


  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={open}
      onClose={close}>
      <DialogTitle classes={{
        root: classes.title
      }}>{'Terms of Service'}</DialogTitle>
      <DialogContent>
        {termsOfService}
      </DialogContent>
      <DialogActions>
        <Button onClick={close} color='primary'>
            Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
